import { MobileMenuItem } from '../app/shared/interfaces/mobile-menu-item';

export const mobileMenu: MobileMenuItem[] = [
    {type: 'link', label: 'Home', url: '/'},
    {type: 'link', label: 'Preferiti', url: '/shop/wishlist'},
    {type: 'link', label: 'Account', url: '/account/dashboard'},
    {type: 'link', label: 'Categorie', url: '/shop/catalog', children: []},
];
